import { File, FileInput } from "../file/file";


export class TemplateVariant {
  id: string;
  htmlCode: string;
  name: string;
  externalId: string;
  templateKey: string;
  isSystem: boolean;
  isActive: boolean;
  isDeletable: boolean;
  attachments: File[];
  plainText: String;
	subject: String;


  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      if (payload?.htmlCode) {
        this.htmlCode = atob(payload.htmlCode);
      }
      this.externalId = payload.externalId;
      this.name = payload.name;
      this.templateKey = payload?.templateKey
      this.isSystem = payload.isSystem;
      this.isActive = payload.isActive;
      this.attachments = payload.attachments;
      this.isDeletable = payload?.isDeletable;
      this.plainText = payload?.plainText;
      this.subject = payload?.subject;
    }
  }

  /**
   * creates  from a result
   * @param result Array of any
   * @returns Array of
   */
  static createTemplateVariants(result: Array<any>): TemplateVariant[] {
    const variants = new Array<TemplateVariant>();
    if (result) {
      result.map((model) => {
        variants.push(new TemplateVariant(model));
      });
    }
    return variants;
  }
}

export class TemplateVariantInput {
  id: string;
  htmlCode: string;
  name: string;
  externalId: string;
  templateKey: string;
  isActive: boolean;;
  attachments: FileInput[];
  plainText: String;
	subject: String;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.htmlCode = payload.htmlCode;
      this.name = payload.name;
      this.externalId = payload.externalId;
      this.templateKey = payload?.templateKey
      this.isActive = payload.isActive;
      this.attachments = payload.attachments;
      this.plainText = payload?.plainText;
      this.subject = payload?.subject;
    }
  }
}
